var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoominicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.28px",
    height: "841.89px",
    viewBox: "0 0 595.28 841.89",
    enableBackground: "new 0 0 595.28 841.89",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "357.594,140.02 263.028,140.02 263.028,304.813 98.233,304.813 98.233,399.308 263.028,399.308  263.028,564.101 357.594,564.101 357.594,399.308 522.315,399.308 522.315,304.813 357.594,304.813  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoominicon);
export default __webpack_public_path__ + "static/media/Zoominicon.661844daf451f8e91686b15e4ff037e1.svg";
export { ForwardRef as ReactComponent };